module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan4-3-d7b941d5ce152553112ee344ceaab406.webp";